import { render, staticRenderFns } from "./JuniorRecharge.vue?vue&type=template&id=154be2c8&scoped=true"
import script from "./JuniorRecharge.vue?vue&type=script&lang=js"
export * from "./JuniorRecharge.vue?vue&type=script&lang=js"
import style0 from "./JuniorRecharge.vue?vue&type=style&index=0&id=154be2c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154be2c8",
  null
  
)

export default component.exports